import React from 'react';
import { connect } from 'react-redux';

import { change as formChange } from 'redux-form';

import { toHourFormat } from '../utils/Completion';

import FCTextWrapper from './FCTextWrapper';

const FCHourWrapper = rest => <FCTextWrapper {...rest} />;

const mapDispatchToProps = (dispatch, ownProps) => ({
  onBlur: value => {
    dispatch(formChange(ownProps.meta.form, ownProps.input.name, toHourFormat(value)));
  }
});

export default connect(null, mapDispatchToProps)(FCHourWrapper);
